const gridLayoutControls = {
    GridLayoutControls: {
        baseStyle: () => ({
            wrapper: {
                gap: {base: 'spacing.2', md: 'spacing.none'},
                p: {
                    textStyle: 'paragraphXs',
                    fontWeight: 400,
                    letterSpacing: '3px',
                },
                flexDirection: {base: 'row-reverse', md: 'row'},
            },
            gridWrapper: {
                flexDirection: 'row',
                alignItems: 'center',
                order: {base: 1, md: 0},
                gap: 'spacing.1',
            },
            icon: {
                cursor: 'pointer',
                p: 'spacing.2',
                _focus: {
                    outline: '2px solid #1e90ff',
                },
            },
        }),
    },
}

export default gridLayoutControls
